import React, { useState, useEffect } from "react";
import AnsprechartnerComponent from '../components/AnsprechartnerComponent';

const AnsprechartnerContainer = (props) => {
    return <AnsprechartnerComponent {...props} />;
};

export default AnsprechartnerContainer;